import { useKibanaLogger } from '../../../shared/hooks/kibana-logger/kibana-logger';
import { dataBuilderStore } from '../data-builder.store';
import type { BuildPayloadInput } from './build-verify-payload';
import { buildVerifyPayload } from './build-verify-payload';
import type {
  DataBuilderPayload,
  DataBuilderSchema,
} from './data-builder-api.types';

export function useBuildDataBuilderPayload(
  input: Pick<BuildPayloadInput, 'client' | 'name'> & {
    datasets?: BuildPayloadInput['datasets'];
  }
) {
  const { kibanaLogger } = useKibanaLogger();

  const build = (schema: DataBuilderSchema): DataBuilderPayload | null => {
    const state = dataBuilderStore.getState();

    try {
      return buildVerifyPayload({
        schema,
        state: {
          datasetInstances: state.datasetInstances,
          configByInstance: state.configByInstance,
          lagData: state.lagData,
          deliveryMethod: state.deliveryMethod,
          deliveryFormat: state.deliveryFormat,
          snowflakeConfig: state.snowflakeConfig,
          s3Config: state.s3Config,
          sftpConfig: state.sftpConfig,
          modelVersions: state.modelVersions,
        },
        client: input.client,
        name: input.name,
        datasets: input.datasets,
      });
      // biome-ignore lint/correctness/noUnusedVariables: migrated from develop
    } catch (error: unknown) {
      kibanaLogger?.error('Data Builder: payload build failed');
      return null;
    }
  };

  return { build };
}
